module.exports = __webpack_public_path__ + "img/6.952cd328.jpeg";